import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { Observable } from 'rxjs';
import { Auth, signInWithPopup, GoogleAuthProvider, signOut, FacebookAuthProvider } from '@angular/fire/auth';
import { SuperAdminProxyService } from '../super-admin-proxy.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiUrlService: ApiUrlService,
    private auth: Auth,
    private readonly superAdminProxy: SuperAdminProxyService
  ) { }
  loginWithGoogle() {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(this.auth, provider);
  }
  loginWithFacebook() {
    const provider = new FacebookAuthProvider();
    return signInWithPopup(this.auth, provider);
  }

  logoutA() {
    return signOut(this.auth);
  }


  signupEmail(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrlService.SEND_MAIL, payload);
  }

  verifyEmail(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrlService.VERIFY_EMAIL, payload);
  }

  setOrganizationPassword(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrlService.SET_PASSWORD, payload);
  }

  resendOtp(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrlService.RESEND_OTP, payload);
  }

  
  userLogin(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrlService.ADMIN_LOGIN, payload);
  }

  createUser(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrlService.CREATE_USER, payload);
  }

  updateUser(id: number, payload: any) {
    return this.http.put<any>(
      `${this.apiUrlService}/${id}`,
      payload
    );
  }
  updateUserById(id: number, payload: any) {
    return this.http.put<any>(
      `${this.apiUrlService.UPDATE_ADMIN_USER_BYID}/${id}`,
      payload
    );
  }

  ADMIN_GROUP_UPDATE(id: string, payload: any) {
    return this.http.put<any>(
      `${this.apiUrlService.ADMIN_GROUP_UPDATE}/${id}`,
      payload
    );
  }

  displayWallet(id: any) {
    return this.http.get(`${this.apiUrlService.GET_WALLET1}`);
  }

  forgetPassword(payload: any) {
    return this.http.post<any>(this.apiUrlService.FORGET_PASSWORD, payload);
  }

  resetPassword(token:any, payload: any) {
    return this.http.post<any>(`${this.apiUrlService.RESET_PASSWORD}/${token}`, payload);
  }

  updatePassword(payload: any) {
    return this.http.post<any>(this.apiUrlService.UPDATE_PASSWORD, payload);
  }

  checkTokenValidation(token: string) {
    return this.http.get<any>(`${this.apiUrlService.TOKEN_VALIDATE}/${token}`);
  }

  getProfile() {
    return this.http.get<any>(this.apiUrlService.GET_USER_PROFILE);
  }

  getUsersWithPagination(payload: any, searchItem: string, role: any) {
    if (!payload.name) {
      delete payload.name;
    }
    payload.type = role;

    return this.http.get<any>(
      `${this.apiUrlService.GET_USER_LIST_PAGINATION}`,
      {
        params: payload,
      }
    );
  }
  getUsersWithPaginationemployee(payload: any, searchItem: string, role: any) {
    if (!payload.name) {
      delete payload.name;
    }
    payload.type = 'employee';

    return this.http.get<any>(
      `${this.apiUrlService.GET_USER_LIST_PAGINATION}`,
      {
        params: payload,
      }
    );
  }
  getMemberListWithPagination(payload: any, searchItem: string, role: any) {
    return this.http.get<any>(
      `${this.apiUrlService.GET_MEMBER_LIST_PAGINATION}?limit=${payload.limit}&currentPage=${payload.currentPage}&type=employee&name=${payload.name}`
    );
  }
  getUsersWithPagination2(payload: any) {
    return this.http.get<any>(
      `${this.apiUrlService.GET_USER_LIST_PAGINATION}`,
      {
        params: payload,
      }
    );
  }
  getUsersWithSearch(payload: any, searchData: any, role: any) {
    return this.http.get<any>(
      `${this.apiUrlService.GET_USER_LIST_PAGINATION}?limit=${payload.limit}&currentPage=${payload.currentPage}&type=${role}&name=${searchData}&kycStatus=${payload.status}`
    );
  }
  GetAdminRoles(payload: any) {
    return this.http.get<any>(
      `${this.apiUrlService.GET_ADMIN_ROLES}?limit=${payload.limit}&currentPage=${payload.currentPage}&type=${payload.role}&title=${payload.title}`
    );
  }

  getUserDetails(id: number) {
    return this.http.get<any>(`${this.apiUrlService.GET_USER_DETAILS}/${id}`);
  }

  getUserDetailsFromSession() {
    const user = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') as any)
      : '';
    return user;
  }
  getUserDetailsFromLocal() {
    const user = localStorage.getItem('Isuser')
      ? JSON.parse(localStorage.getItem('Isuser') as any)
      : '';
    return true;
  }
  getUserRole() {
    let role = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user') as any).user.role_name
      : '';
    // let roles = [ 'merchant'];
    // if(!roles.includes(role)) {
    //   role = 'admin';
    // }
    // console.log(role);
    return role;
  }

  /** JWT account class: 1=super admin, 2=org, 3=staff, 4=user, 5=branch, 6=client */
  getJwtAccountType(): number | null {
    try {
      const session = this.getUserDetailsFromSession();
      const token = session?.token;
      if (!token || typeof token !== 'string') return null;
      const parts = token.split('.');
      if (parts.length < 2) return null;
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
      const type = payload?.type;
      return typeof type === 'number' ? type : parseInt(String(type), 10) || null;
    } catch {
      return null;
    }
  }

  getJwtUserId(): number | null {
    try {
      const session = this.getUserDetailsFromSession();
      const token = session?.token;
      if (!token || typeof token !== 'string') return null;
      const parts = token.split('.');
      if (parts.length < 2) return null;
      const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
      const id = payload?.id;
      return typeof id === 'number' ? id : parseInt(String(id), 10) || null;
    } catch {
      return null;
    }
  }

  /** Staff (3) or Users-table account (4) — sees only assigned projects / own data. */
  isScopedEndUser(): boolean {
    const t = this.getJwtAccountType();
    return t === 3 || t === 4;
  }

  isOrganizationAdmin(): boolean {
    return this.getJwtAccountType() === 2;
  }

  isSuperAdmin(): boolean {
    return this.getJwtAccountType() === 1;
  }

  isLoggedIn() {
    return localStorage.getItem('user') as any;
  }

  logout() {
    this.superAdminProxy.clearProxy();
    localStorage.clear();
  }

  // ----------------------------------------------

  ADMIN_GROUP_CREATE(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrlService.ADMIN_GROUP_CREATE, payload);
  }
  ADMIN_GROUP_GET_WITH_PAGINATE(payload: any) {
    // return this.http.get<any>(this.apiUrlService.ADMIN_GROUP_GET_WITH_PAGINATE);
    return this.http.get<any>(
      `${this.apiUrlService.ADMIN_GROUP_GET_WITH_PAGINATE}?limit=${payload.limit}&currentPage=${payload.currentPage}&type=${payload.role}&title=${payload.title}`
    );
  }

  DELETE_GROUP(payload: any) {
    return this.http.post<any>(this.apiUrlService.DELETE_GROUP, payload);
  }

  DELETE_ROLE(payload: any) {
    return this.http.post<any>(this.apiUrlService.DELETE_ROLE, payload);
  }

  ADMIN_ROLE_CREATE(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrlService.CREATE_ROLE, payload);
  }

  ADMIN_ROLE_UPDATE(id: string, payload: any) {
    return this.http.put<any>(
      `${this.apiUrlService.UPDATE_ROLE}/${id}`,
      payload
    );
  }

  ADMIN_GROUP_GET_ALL_PERMISSION(payload: any) {
    return this.http.get<any>(
      `${this.apiUrlService.GET_ALL_PERMISSION}?limit=${payload.limit}&name=${payload.currentPage}`
    );
  }

  getAllPermissions() {
    return this.http.get<any>(`${this.apiUrlService.GET_ALL_PERMISSIONS}`);
  }

  GET_GROUP_DETAILS(payload: any) {
    return this.http.get<any>(
      `${this.apiUrlService.GET_GROUP_DETAILS}?id=${payload._id}`
    );
  }

  GET_ALL_MEMBERS(payload: any) {
    return this.http.get<any>(`${this.apiUrlService.GET_ALL_MEMBERS}`, {
      params: payload,
    });
  }

  // GetEmployeeManagement(payload:any) {
  //   return this.http.get<any>(`${this.apiUrlService.EMPLOYEE_MANAGEMENT_GETW_WITH_PAGINATE}?limit=${payload.limit}&currentPage=${payload.currentPage}&type=${payload.role}`);
  // }

  GetRoleAndPermission(payload: any) {
    return this.http.get<any>(
      `${this.apiUrlService.GET_ROLE}?limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  }
  GET_ALL_ROLE() {
    return this.http.get<any>(`${this.apiUrlService.GET_ALL_ROLE}`);
  }
  GET_ALL_GROUP() {
    return this.http.get<any>(`${this.apiUrlService.GET_ALL_GROUP}`);
  }
  GetMembership(payload: any) {
    return this.http.get<any>(
      `${this.apiUrlService.GET_MEMBERS}?limit=${payload.limit}&currentPage=${payload.currentPage}&type=${payload.role}`
    );
  }
}
